/* eslint-disable camelcase */
import React, {
  useState, useEffect
} from 'react';
import {
  Card, Menu, Dropdown, Layout, Row, Col, Button, Input, Table, Modal, message, Space, Avatar, Upload,
} from 'antd';
import { Link, Redirect } from 'react-router-dom';
import Axios from 'axios';
import moment from 'moment';
import {
  UserOutlined,
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  ImportOutlined,
  ExportOutlined,
  UploadOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import fileDownload from 'js-file-download';
import { url } from '../../config/global';
import './User.css';

const { Search } = Input;
const { Content } = Layout;

function User() {
  const [keyword, setKeyword] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonAccess, setButtonAccess] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState({
    sort: 'full_name',
    order: 'ascend',
  });
  const [data, setData] = useState({
    file: null,
  });
  const [importIsOpen, setImportIsOpen] = useState(false);

  const handleSearch = (value) => {
    setKeyword(value);
  };

  const getData = (val_keyword, va_page, val_sort) => {
    setLoading(true);
    Axios.get(`${url}/user`, {
      params: {
        keyword: val_keyword,
        columns: [
          'username',
          'full_name',
          'npk',
          'division',
          'department',
          'position',
          'email',
          'number_phone',
        ],
        perpage: 10,
        page: va_page,
        sort: val_sort.sort,
        order: val_sort.order,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      setUsers(res.data);
    }).catch((err) => {
      if (err.response) {
        message.error(err.response.data.message);
        if (err.response.status === 401) {
          sessionStorage.removeItem('token');
        }
      }
    }).finally(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    getData(keyword, page, sort);

    const pathname = window.location.pathname.split('/');
    const currentUrl = pathname[1];
    const permissions = sessionStorage.getItem('permissions')
      && JSON.parse(sessionStorage.getItem('permissions'));

    if (permissions) {
      // const findPermission = permissions.find(
      //   (permission) => permission.url === currentUrl,
      // );
      const findChildPermission = permissions
        .map((child) => child.children.find(
          (grandChild) => grandChild.url === currentUrl,
        ))
        .filter((grandChild) => grandChild)[0];

      if (findChildPermission && findChildPermission.children) {
        if (findChildPermission.children) {
          const findButtonAccessChildren = findChildPermission.children
            .filter((x) => x !== null)
            .filter((x) => x.permission_type === 'button');
          if (findButtonAccessChildren) {
            setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
          }
        }
      }
      // if (findPermission && findPermission.children) {
      //   const findButtonAccess = findPermission.children.filter(
      //     (x) => x.permission_type === 'button',
      //   );
      //   if (findButtonAccess) {
      //     setButtonAccess(findButtonAccess);
      //   }
      // }
    }
  }, [keyword, page, sort]);

  const confirmDelete = (id) => {
    setLoading(true);
    Axios.delete(`${url}/user/${id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    }).then((res) => {
      message.success(res.data.message);
      getData(keyword, page, sort);
    }).catch((err) => {
      if (err.response) {
        message.error(err.response.data.message);
        if (err.response.status === 401) {
          sessionStorage.removeItem('token');
        }
      }
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: 'Are you sure?',
      content: (
        <div>
          <p>Deleted data cannot be restored</p>
        </div>
      ),
      okText: 'Delete',
      showCancel: true,
      onCancel: () => {

      },
      cancelText: 'Cancel',
      confirmLoading: loading,
      onOk: async () => {
        confirmDelete(id);
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setData({
      ...data,
      file: null,
    });
    setIsModalVisible(false);
  };

  const handleRemove = () => {
    setIsModalVisible(false)
    setData({
      ...data,
      file: null,
    });
  };

  const handleBeforeUpload = (files) => {
    setData({
      ...data,
      file: files,
    });

    return false;
  };

  const exportExcelUser = () => {
    Axios.get(`${url}/export/user`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
      responseType: 'blob',
    }).then((res) => {
      fileDownload(res.data, 'Export User.xlsx');
    });
  };

  const templateExcelUser = () => {
    Axios.get(`${url}/template/user`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
      responseType: 'blob',
    }).then((res) => {
      fileDownload(res.data, 'Template_User.xlsx');
    });
  };

  const onSaveData = () => {
    setLoading(true);

    const fd = new FormData();
    if (data.file) {
      fd.append('file_user', data.file);
  
      Axios.post(`${url}/import/user`, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
        .then((res) => {
          closeModal();
          getData(keyword, page, sort);
          message.success(res.data.message);
        })
        .catch((err) => {
          if (err.response) {
            message.error(err.response.data.message);
            if (err.response.status === 422) {
              message.error(err.response.data.errors);
            }
            if (err.response.status === 401) {
              localStorage.removeItem('token');
            }
          }
          setLoading(false);
        });
    } else {
      setLoading(false);
      message.error('Pilih file terlebih dahulu');
    }
  };

  const columns = [
    {
      title: 'Photo',
      dataIndex: 'photo_url',
      sorter: false,
      fixed: 'left',
      render: (photo_url) => (photo_url ? <Avatar src={photo_url} /> : <Avatar icon={<UserOutlined />} />),
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      sorter: true,
      fixed: 'left',
    },
    {
      title: 'Full Name',
      dataIndex: 'full_name',
      key: '1',
      sorter: true,
    },
    {
      title: 'Npk',
      dataIndex: 'npk',
      key: '2',
      sorter: true,
    },
    {
      title: 'Division',
      dataIndex: 'division',
      key: '3',
      sorter: true,
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: '4',
      sorter: true,
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: '5',
      sorter: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: '6',
      width: 200,
      sorter: true,
    },
    {
      title: 'Phone',
      dataIndex: 'number_phone',
      key: '7',
      sorter: true,
    },
    {
      title: 'User Type',
      dataIndex: 'user_type',
      key: '8',
      sorter: true,
    },
    {
      title: 'Role',
      dataIndex: 'role_name',
      key: '9',
      sorter: true,
    },
    {
      title: '',
      dataIndex: '_id',
      align: 'right',
      sorter: false,
      fixed: 'right',
      key: 'operation',
      width: 100,
      render: (id) => (
        <>
          <Dropdown
            className="pointer"
            overlay={(
              <Menu>
                {buttonAccess
                  && buttonAccess.find((x) => x.url === 'user/view') && (
                    <Menu.Item key="1">
                      <Link to={`/user/view/${id}`}>
                        <InfoCircleOutlined />
                        {' '}
                        View
                      </Link>
                    </Menu.Item>
                  )}

                {buttonAccess
                  && buttonAccess.find((x) => x.url === 'user/edit') && (
                    <Menu.Item key="2">
                      <Link to={`/user/edit/${id}`}>
                        <EditOutlined />
                        {' '}
                        Edit
                      </Link>
                    </Menu.Item>
                  )}

                {buttonAccess
                  && buttonAccess.find((x) => x.url === 'user/delete') && (
                    <Menu.Item key="3">
                      <span onClick={() => handleDelete(id)}>
                        <DeleteOutlined />
                        Delete
                      </span>
                    </Menu.Item>
                  )}
              </Menu>
            )}
            trigger={['click']}
          >
            <span className="pointer" onClick={(e) => e.preventDefault()}>
              <MoreOutlined />
            </span>
          </Dropdown>
        </>
      ),
    },
  ];

  return sessionStorage.getItem('token') ? (
    <>
      <Content className="content m-0">
        <Row>
          <Col xs={24}>
            <Card className="body-data">

              <Row type="flex" gutter={[10, 20]} justify="space-around">
                <Col xs={24} md={12} lg={18}>
                  <Space>
                    {buttonAccess
                      && buttonAccess.find((x) => x.url === 'user/create') && (
                        <Link to="/user/create">
                          <Button type="primary" className="btn-success">
                            <PlusOutlined />
                            Add
                          </Button>
                        </Link>
                      )}

                    {buttonAccess
                      && buttonAccess.find((x) => x.url === 'user/create') && (
                        <Button type="primary" className="btn-success" onClick={showModal}>
                          <UploadOutlined />
                          Import Users
                        </Button>
                      )}
                    
                    {buttonAccess
                      && buttonAccess.find((x) => x.url === 'user/create') && (
                        <Button type="primary" className="btn-success" onClick={exportExcelUser}>
                          <DownloadOutlined />
                          Export Users
                        </Button>
                      )}

                    {buttonAccess
                      && buttonAccess.find((x) => x.url === 'user/import') && (
                        <Button type="primary" onClick={showModal}>
                          <ImportOutlined />
                          Import
                        </Button>
                      )}

                    {buttonAccess
                      && buttonAccess.find((x) => x.url === 'user/export') && (
                        <Button onClick={exportExcelUser} type="primary">
                          <ExportOutlined />
                          Export
                        </Button>
                      )}

                    <Modal
                      title="Import User"
                      visible={isModalVisible}
                      footer={[
                        <Button htmlType="reset" onClick={handleRemove}>
                          Cancel
                        </Button>,
                        <Button
                          loading={loading}
                          onClick={onSaveData}
                          type='primary'
                          className='btn-success'
                        >
                          Upload
                        </Button>,
                      ]}
                      onCancel={closeModal}
                    >
                      <div>
                        
                      </div>
                        <Upload
                          onRemove={handleRemove}
                          beforeUpload={handleBeforeUpload}
                          fileList={[]}
                          accept='.xlsx,.xls'
                        >
                          <Button style={{ marginBottom: 10 }}>
                            Choose File
                            <ImportOutlined />
                          </Button>
                        </Upload>
                        {data.file && (
                          <React.Fragment
                            children={[
                              <Button onClick={handleRemove} type="danger" ghost>
                                <DeleteOutlined />
                              </Button>,
                            ]}
                          >
                            {data.file.name ? data.file.name : data.file}
                          </React.Fragment>
                        )}
                        <p><a onClick={templateExcelUser} className='text-info'>Download template</a> sebelum upload untuk memastikan format sudah sesuai</p>
                    </Modal>

                  </Space>
                </Col>
                <Col xs={24} md={12} lg={6} className="align-right">
                  <Search
                    placeholder="Search ..."
                    onSearch={(value) => handleSearch(value)}
                  />
                </Col>

                <Col xs={24}>
                  <Table
                    columns={columns}
                    dataSource={users.data}
                    rowKey={(val) => val._id}
                    onChange={handleTableChange}
                    scroll={{ x: true }}
                    pagination={{
                      pageSize: 10, current: page, total: users.total, showSizeChanger: false,
                    }}
                    loading={loading}
                  />
                </Col>
              </Row>

            </Card>
          </Col>
        </Row>
      </Content>
    </>
  ) : <Redirect to="/login" />
}

export default User;